<template>
  <v-btn @click="$router.go(-1)" class="ma-2 mr-4" outlined small tile>
    <v-icon class="mr-2" small>fas fa-arrow-left</v-icon>
    Назад
  </v-btn>
</template>
<script>
export default {
}
</script>